import {routes as analyticsReport} from './analytics/routes'
import {routes as knowledgeTierReport} from './knowledge-tiers/routes'
import {routes as onboardingSession} from './onboarding-sessions/routes'
import {routes as otherClicksReport} from './other-clicks/routes'
import {routes as promotionsReport} from './promotions/routes'
import {routes as todayReport} from './today/routes'
import {routes as topArticlesReport} from './top-articles/routes'
import {routes as topSourcesReport} from './top-sources/routes'
import {routes as topTopicsReport} from './top-topics/routes'

export const routes = []
  .concat(analyticsReport)
  .concat(otherClicksReport)
  .concat(knowledgeTierReport)
  .concat(promotionsReport)
  .concat(todayReport)
  .concat(topArticlesReport)
  .concat(topSourcesReport)
  .concat(topTopicsReport)
  .concat(onboardingSession)



// WEBPACK FOOTER //
// ./src/pages/reports/routes.tsx